/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import SubSkillDataFields, { SubSkillGridConfig } from "./SubSkill.Data";
import FormCreator from "../../../components/FinalForms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import MolGrid from "../../../components/Grid/MolGrid";
import { hasFunctionalPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";
import { securityKey } from "../../../data/SecurityKey";
import { useAddEditSubSkillMutation, useDeleteSubSkillMutation, useGetSubSkillMutation, useLazyGetSubSkillBySubSkillIdQuery } from "../../../app/services/subSkillAPI";
import ToastService from "../../../services/toastService/ToastService";
import { onResetForm } from "../../../utils/FormFields/ResetForm/handleResetForm";
import SwalAlert from "../../../services/swalService/SwalService";

const AddSubSkill = (props) => {
  const ref = useRef();
  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  const [userForm, setUserForm] = useState(SubSkillDataFields);
  const [listData, setListData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [subSkillId, setSubskillId] = useState(null);
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const [addEditSubSkill, { isLoading: isAddEditSkillCategoriesLoading, isSuccess: isAddEditSkillCategoriesSuccess, data: isAddEditSkillCategoriesData, }] = useAddEditSubSkillMutation();
  const [getSubSkill, { isLoading: isGetSubSkillLoading, isSuccess: isGetSubSkillSuccess, data: isGetSubSkillData, },] = useGetSubSkillMutation();
  const [deleteSubSkill, { isSuccess: isDeleteSubSkillSuccess, data: isDeleteSubSkillData },] = useDeleteSubSkillMutation();
  const [getSubSkillBySubSkillId, { isFetching: isGetSubSkillBySubSkillIdFetching, isSuccess: isGetSubSkillBySubSkillIdSuccess, data: GetSubSkillBySubSkillIdData, },] = useLazyGetSubSkillBySubSkillIdQuery();
  //const hasEditPermission = hasFunctionalPermission(securityKey.EDITSUBSKILL);
  const hasDeletePermission = hasFunctionalPermission(securityKey.DELETESUBSKILL);
  const actionColumn = SubSkillGridConfig.columns.find(column => column.name === "Action");
//    useEffect(() => {

//     if (subSkillId) {
//         if (hasEditPermission.isViewOnly === true) {
//             formSetting.isViewOnly = true;
//             setIsButtonDisable(true)
//         }else{
//           formSetting.isViewOnly = false;
//           setIsButtonDisable(true)
//         }
//     }
// }, [hasAddPermission, hasEditPermission, formSetting.isViewOnly]);

  // useEffect(() => {
  //   if (hasEditPermission?.isViewOnly === true) {
  //     actionColumn.defaultAction.allowEdit = true;
  //   }
  //   else if (hasEditPermission?.isEditable === true) {
  //     actionColumn.defaultAction.allowEdit = true;
  //   }
  //   else {
  //     actionColumn.defaultAction.allowEdit = false;
  //   }
  // }, [hasEditPermission, actionColumn?.defaultAction?.allowEdit]);

  useEffect(() => {
    if (hasDeletePermission?.hasAccess === true) {
      actionColumn.defaultAction.allowDelete = true;
    }
    else if (hasDeletePermission?.hasAccess === false) {
      actionColumn.defaultAction.allowDelete = false;
    }
  }, [hasDeletePermission, actionColumn?.defaultAction?.allowDelete]);

  useEffect(() => {
    if (props.isModelOpen && props.mainSkillId) {
      onGetData();
    }
  }, [props.isModelOpen, props.mainSkillId]);

  useEffect(() => {
    if (!isGetSubSkillBySubSkillIdFetching && isGetSubSkillBySubSkillIdSuccess && GetSubSkillBySubSkillIdData) {
      const newFrom = { ...SubSkillDataFields };
      newFrom.initialState = {
        mainSkillId: GetSubSkillBySubSkillIdData.mainSkillId,
        subSkillName: GetSubSkillBySubSkillIdData.subSkillName,
        subSkillId: GetSubSkillBySubSkillIdData.subSkillId,
        description : GetSubSkillBySubSkillIdData.description
      };
      setUserForm(newFrom);
      setSubskillId(GetSubSkillBySubSkillIdData.subSkillId);
    }
  }, [isGetSubSkillBySubSkillIdFetching, isGetSubSkillBySubSkillIdSuccess, GetSubSkillBySubSkillIdData])
  useEffect(() => {
    if (isGetSubSkillSuccess && isGetSubSkillData) {
      if (isGetSubSkillData) {
        setListData(isGetSubSkillData.dataSource);
      }
      if (isGetSubSkillData.totalRecord) {
        setTotalRowCount(isGetSubSkillData.totalRecord);
      }
    }
  }, [isGetSubSkillSuccess, isGetSubSkillData]);

  const getLists = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      filters: { searchText: "" },
      mainSkillId: props.mainSkillId,
    };

    getSubSkill(request);
  };

  const handlePageChange = (page) => {
    getLists(page);
  };

  const onGetData = () => {
    if (molGridRef.current) {
      const defaultPageObject = molGridRef.current.getCurrentPageObject();
      getLists(defaultPageObject);
    }
  };
  const handleResetAndClose = () => {
    onResetForm(SubSkillDataFields, setUserForm, null);
    props.onCloseSidebar();
  };

  useEffect(() => {
    if (isAddEditSkillCategoriesSuccess && isAddEditSkillCategoriesData) {
      if (isAddEditSkillCategoriesData.errorMessage.includes("exists")) {
        ToastService.warning(isAddEditSkillCategoriesData.errorMessage);
        return;
      }
      onResetForm(SubSkillDataFields, setUserForm, null);
      onGetData();
      setSubskillId(null)
      ToastService.success(isAddEditSkillCategoriesData.errorMessage);
    }
  }, [isAddEditSkillCategoriesSuccess, isAddEditSkillCategoriesData])

  const handleSubSkillAdd = () => {

    const formData = ref.current.getFormData();
    if (formData && props.mainSkillId) {
      const request = {
        subSkillId: subSkillId || 0,
        subSkillName: formData.subSkillName,
        mainSkillId: props.mainSkillId,
        description: formData.description
      }
      addEditSubSkill(request)
    }
  }
  useEffect(() => {
    if (isDeleteSubSkillSuccess && isDeleteSubSkillData) {
      ToastService.success(isDeleteSubSkillData.errorMessage);
      onGetData();
    }
  }, [isDeleteSubSkillSuccess, isDeleteSubSkillData]);
  const handleDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteSubSkill(data.subSkillId);
      }
    });
  };

  const handleEditClick = (data) => {
    getSubSkillBySubSkillId(data.subSkillId);
  };
  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick,
  };
  return (
    <>
      <div className="skill-add-sec">
        <form>
          <div className="row mt-2">
            <FormCreator
              config={userForm}
              ref={ref}
              {...userForm}
            />
          </div>
        </form>
        <div className="row">
          <div className="col-12">
            <div className="form-btn d-flex align-items-center justify-content-end mb-2">
              <Buttons
                buttonTypeClassName="dark-btn mr-5"
                onClick={handleResetAndClose}
                buttonText="Cancel"
              />
              <Buttons
                buttonTypeClassName="theme-btn"
                isDisable ={isButtonDisable}
                onClick={handleSubSkillAdd}
                buttonText={subSkillId ? "Update" : "Add"}
                isLoading={isAddEditSkillCategoriesLoading}
              />


            </div>
          </div>
        </div>
      </div>
      <div className="table-body-scroll">
        <MolGrid
          ref={molGridRef}
          configuration={SubSkillGridConfig}
          dataSource={listData}
          allowPagination={false}
          pagination={{
            totalCount: totalRowCount,
            pageSize: 20,
            currentPage: 1,
          }}
          isLoading={isGetSubSkillLoading}
          onActionChange={actionHandler}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default AddSubSkill;
